import { render } from "./categories.vue?vue&type=template&id=31cd36b6&scoped=true&ts=true"
import script from "./categories.vue?vue&type=script&lang=ts"
export * from "./categories.vue?vue&type=script&lang=ts"

import "./categories.vue?vue&type=style&index=0&id=31cd36b6&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31cd36b6"]])

export default __exports__